import React, { useState, useEffect } from "react";

import { CCol, CProgress, CRow, CSelect } from "@coreui/react";

import Charts from "../../Charts";
import "./styles.scss";

const AtividadeAluno = ({ roomUser }) => {
  const [concluido, setConcluido] = useState(null);
  const [tipos, setTipos] = useState([]);
  const [disciplinas, setDisciplinas] = useState([]);
  const [professores, setProfessores] = useState([]);
  const [tipo, setTipo] = useState("0");
  const [disciplina, setDisciplina] = useState("0");
  const [professor, setProfessor] = useState("0");

  useEffect(() => {
    if (roomUser) {
      let naoConcluido = roomUser.filter(
        execution =>
          execution.activity_type !== 2 && execution.completion_percentage < 100
      ).length;
      let aux = [];

      let concluido2 = roomUser.filter(
        execution =>
          execution.activity_type !== 2 &&
          execution.completion_percentage >= 100
      ).length;
      aux.push({ Nao_Concluido: naoConcluido, Concluido: concluido2 });
      setConcluido(aux);

      setTipos(
        roomUser.filter(
          (v, i, a) =>
            a.findIndex(item => item.activity_type === v.activity_type) === i &&
            v.activity_type !== 2
        )
      );
      setDisciplinas(
        roomUser.filter(
          (v, i, a) =>
            a.findIndex(item => item.discipline_id === v.discipline_id) === i &&
            v.discipline_id
        )
      );
      setProfessores(
        roomUser.filter(
          (v, i, a) =>
            a.findIndex(item => item.user_id === v.user_id) === i && v.user_id
        )
      );
    }
  }, [roomUser]);

  if (!roomUser) {
    return <span>Carregando...</span>;
  }

  const filteredRoomUser = roomUser.filter(
    execution =>
      execution.activity_type !== 2 &&
      (!parseInt(tipo) || execution.activity_type === parseInt(tipo)) &&
      (!parseInt(disciplina) ||
        execution.discipline_id === parseInt(disciplina)) &&
      (!parseInt(professor) || execution.user_id === parseInt(professor))
  );

  return (
    <>
      <div className="layoutTabela">
        <CRow className="mb-4">
          <CCol>
            <CSelect value={tipo} onChange={e => setTipo(e.target.value)}>
              <option value={0}>Todos os tipos</option>
              {tipos.map(tipo => (
                <option value={tipo.activity_type}>{tipo.type_name}</option>
              ))}
            </CSelect>
          </CCol>
          <CCol>
            <CSelect
              value={disciplina}
              onChange={e => setDisciplina(e.target.value)}
            >
              <option value={0}>Todas as disciplinas</option>
              {disciplinas.map(disciplina => (
                <option value={disciplina.discipline_id}>
                  {disciplina.discipline_name}
                </option>
              ))}
            </CSelect>
          </CCol>
          <CCol>
            <CSelect
              value={professor}
              onChange={e => setProfessor(e.target.value)}
            >
              <option value={0}>Todos os professores</option>
              {professores.map(professor => (
                <option value={professor.user_id}>{professor.user_name}</option>
              ))}
            </CSelect>
          </CCol>
        </CRow>
        <table className="table table-hover table-outline mb-0 d-none d-sm-table">
          <thead className="thead-light">
            <tr>
              <th>Atividade</th>
              <th>Tipo</th>
              <th>Disciplina</th>
              <th>Professor</th>
              <th>Data</th>
              <th>% Conclusão</th>
              <th>Nota</th>
            </tr>
          </thead>
          <tbody>
            {filteredRoomUser.map(execution => (
              <tr key={execution.id}>
                <td>{execution.activity_name}</td>
                <td>{execution.type_name}</td>
                <td>{execution.discipline_name}</td>
                <td>{execution.user_name}</td>
                <td>
                  {execution.start
                    ? new Date(
                        execution.start.replace(" ", "T")
                      ).toLocaleDateString()
                    : ""}
                </td>
                <td>
                  <div className="clearfix">
                    <div className="float-left">
                      <strong>{execution.completion_percentage || 0}%</strong>
                    </div>
                  </div>
                  <CProgress
                    className="progress-xs"
                    color={
                      execution.completion_percentage > 50
                        ? "success"
                        : execution.completion_percentage <= 50 &&
                          execution.completion_percentage >= 30
                        ? "warning"
                        : "danger"
                    }
                    value={execution.completion_percentage}
                  />
                </td>
                <td>{execution.grade || ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        className="management-1statistics mb-5"
        style={{ marginTop: "50px" }}
      >
        <div className="row">
          <div className="chart novo">
            <Charts
              type="pie"
              title="Percentual de conclusão"
              data={{
                labels: ["Não concluídos", "Concluídos"],
                datasets: [
                  {
                    data: [
                      filteredRoomUser.filter(
                        execution => execution.completion_percentage < 100
                      ).length,
                      filteredRoomUser.filter(
                        execution => execution.completion_percentage >= 100
                      ).length
                    ],
                    backgroundColor: [
                      "rgba(255, 99, 132, 0.2)",
                      "rgba(75, 192, 192, 0.2)"
                    ],
                    borderColor: [
                      "rgba(255, 99, 132, 1)",
                      "rgba(75, 192, 192, 1)"
                    ],
                    borderWidth: 1
                  }
                ]
              }}
            />
          </div>
        </div>
      </div>

      {/* <div className="layoutTabela" style={{ marginTop: "50px" }}>
        <CRow>
          <CCol>
            <CCard>
              <CCardHeader>
                <b>Resumo</b>
              </CCardHeader>
              <CCardBody>
                <CDataTable
                  items={concluido}
                  hover
                  striped
                  bordered
                  size="sm"
                  itemsPerPage={10}
                  pagination
                />
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </div> */}
    </>
  );
};

export default AtividadeAluno;
